<div
  class="rounded-radius-circle flex justify-center items-center"
  [ngClass]="[STATUS_PROPERTIES_MAP[status()].bgColorClass, STATUS_PROPERTIES_MAP[status()].dropShadowClass, containerClasses() ?? '']"
>
  <svg-icon
    [key]="
      iconVariant() === '16'
        ? STATUS_PROPERTIES_MAP[status()].iconName16[connectorType() ?? DEFAULT_CONNECTOR_TYPE]
        : STATUS_PROPERTIES_MAP[status()].iconName40[connectorType() ?? DEFAULT_CONNECTOR_TYPE]
    "
    class="text-foreground-secondary-100 dark:text-foreground-primary-100"
    [size]="iconSize()"
  ></svg-icon>
</div>
